import Bugsnag from '@bugsnag/js'

window.Bugsnag = Bugsnag
